// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__a834v","myInfoBtn":"Button_myInfoBtn__n4sus"};